module.exports = __webpack_public_path__ + "img/tddg-6.dc03efd8.webp";